/* ---------- live crystal viewer ---------- */
(function () {
  var srcImg = document.getElementById('chPhotoSrc');
  var canvas = document.getElementById('chCanvas');
  var stage  = document.getElementById('chStage');
  var fb     = document.getElementById('chFallback');
  var finale = document.getElementById('chFinaleSrc');
  if (fb && finale) fb.src = finale.src;

  function boot() {
    if (!window.CrystalHouseViewer) { stage.setAttribute('data-fallback', 'true'); return; }
    var v = window.CrystalHouseViewer({
      canvas: canvas, photo: srcImg, stage: stage,
      names: (document.getElementById('chNames') || {}).value || '',
      date:  (document.getElementById('chDate')  || {}).value || '',
      ink: [0.133, 0.110, 0.098]
    });
    if (!v) return;
    var n = document.getElementById('chNames'), d = document.getElementById('chDate'), t;
    function upd() {
      clearTimeout(t);
      t = setTimeout(function () { v.setEngraving(n.value, d.value); }, 90);
    }
    n.addEventListener('input', upd);
    d.addEventListener('input', upd);
  }
  function fail() { if (stage) stage.setAttribute('data-fallback', 'true'); }
  if (!srcImg || !stage) { fail(); return; }
  if (srcImg.complete) {
    // complete with no pixels means the load already failed, and no event is coming
    if (srcImg.naturalWidth) boot(); else fail();
  } else {
    srcImg.addEventListener('load', boot);
    srcImg.addEventListener('error', fail);
  }
})();

/* ---------- collection tile artwork, reused from the page ---------- */
(function () {
  var map = {
    tileSig:    'chFinaleSrc',
    tileCouple: 'chCarveSrc',
    tileParents:'chBowlSrc',
    tileBrides: null,
    tileGroom:  'chGroomSrc',
    tileParty:  null,
    tileRecep:  'chToastSrc',
    tileAnniv:  null,
    tileKeep:   null
  };
  var cdn = {};
  try {
    var ta = document.getElementById('ch-tile-art');
    if (ta) cdn = JSON.parse(ta.textContent);
  } catch (e) {}
  Object.keys(map).forEach(function (id) {
    var el = document.getElementById(id); if (!el) return;
    if (map[id]) { var s = document.getElementById(map[id]); if (s) el.src = s.src; }
    else if (cdn[id]) { el.src = cdn[id]; }
  });
})();

/* ---------- the curation engine ---------- */
(function () {
  function readJSON(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  // Live from Shopify: handles, prices, images and links are rendered by Liquid.
  var PRODUCTS = readJSON('ch-product-data', []);
  var SIG = readJSON('ch-signature-data', null);
  if (SIG) PRODUCTS = PRODUCTS.concat([SIG]);
  if (!PRODUCTS.length) return;

  var Q = {
    recipient: [['couple','The couple'],['parents','Parents'],['bridesmaids','Bridesmaids'],['groomsmen','Groomsmen'],['party','Wedding party'],['reception','The reception'],['anniversary','An anniversary'],['keepsake','A keepsake']],
    occasion:  [['engagement','Engagement'],['shower','Shower'],['rehearsal','Rehearsal dinner'],['day','The wedding day'],['first','First anniversary'],['milestone','Milestone anniversary']],
    style:     [['classic','Classic'],['modern','Modern'],['sentimental','Sentimental'],['story','Their story']],
    budget:    [['1','Under $100'],['2','$100 to $250'],['3','$250 and up'],['0','Show me the range']]
  };

  var LEAD = {
    engagement:'Engagements run early, which is the easiest brief we get. Four weeks is plenty for engraved glassware.',
    shower:    'Order about five weeks before the shower. Three is still workable for glassware.',
    rehearsal: 'Work back from the wedding date. Six weeks before the rehearsal dinner keeps it calm.',
    day:       'For the day itself, six to eight weeks before the wedding is comfortable. Three to five is very doable for engraved glassware.',
    first:     'A first anniversary is a date you already know. Four weeks is enough.',
    milestone: 'Milestone anniversaries usually want the deeper carving, so allow eight weeks.'
  };

  var pick = { recipient:null, occasion:null, style:null, budget:null };
  var els = { recipient:document.getElementById('qRecipient'), occasion:document.getElementById('qOccasion'),
              style:document.getElementById('qStyle'), budget:document.getElementById('qBudget') };
  if (!els.recipient) return;

  Object.keys(Q).forEach(function (k) {
    Q[k].forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'opt'; b.textContent = o[1];
      b.setAttribute('aria-pressed', 'false'); b.dataset.v = o[0];
      b.addEventListener('click', function () {
        pick[k] = (pick[k] === o[0]) ? null : o[0];
        [].forEach.call(els[k].children, function (c) {
          c.setAttribute('aria-pressed', c.dataset.v === pick[k] ? 'true' : 'false');
        });
        render();
      });
      els[k].appendChild(b);
    });
  });

  var rHead = document.getElementById('rHead'), rSub = document.getElementById('rSub'),
      rPicks = document.getElementById('rPicks'), rTiming = document.getElementById('rTiming'),
      rCta = document.getElementById('rCta'), rMail = document.getElementById('rMail');

  function score(p) {
    var s = 0;
    if (pick.recipient) { if (p.to.indexOf(pick.recipient) < 0) return -1; s += 4; }
    if (pick.style)     { s += p.st.indexOf(pick.style) === 0 ? 3 : (p.st.indexOf(pick.style) > 0 ? 2 : 0); }
    if (pick.budget && pick.budget !== '0') {
      var gap = Math.abs(p.band - parseInt(pick.budget, 10));
      s += gap === 0 ? 5 : (gap === 1 ? 1 : -3);
    }
    if (pick.occasion === 'milestone' || pick.occasion === 'first') { if (p.to.indexOf('anniversary') >= 0) s += 2; }
    if (pick.occasion === 'day' && p.to.indexOf('reception') >= 0) s += 1;
    return s;
  }

  function budgetNote(p) {
    if (!pick.budget || pick.budget === '0') return '';
    var want = parseInt(pick.budget, 10);
    if (p.band === want) return '';
    return p.band > want ? 'A step above the range you set' : 'Below the range you set';
  }

  function money(p) { return p.quote ? p.price : (p.from ? 'From ' : '') + p.price; }

  function render() {
    var answered = Object.keys(pick).filter(function (k) { return pick[k]; }).length;
    if (answered < 2) {
      rHead.innerHTML = 'Answer the four above and <em>we will pick three.</em>';
      rSub.textContent = 'Every recommendation includes complimentary standard personalization and an artwork proof before anything is cut.';
      rPicks.innerHTML = ''; rTiming.hidden = true; rCta.hidden = true;
      return;
    }
    var list = PRODUCTS.map(function (p) { return { p:p, s:score(p) }; })
                       .filter(function (x) { return x.s > -1; })
                       .sort(function (a, b) { return b.s - a.s; })
                       .slice(0, 3);

    if (!list.length) {
      rHead.innerHTML = 'Nothing in the collection matches <em>all four.</em>';
      rSub.textContent = 'Loosen the budget, or email Elias with what you have in mind and he will find it.';
      rPicks.innerHTML = ''; rTiming.hidden = true; rCta.hidden = false;
      return;
    }

    var who = (Q.recipient.filter(function (o) { return o[0] === pick.recipient; })[0] || ['', 'this wedding'])[1].toLowerCase();
    rHead.innerHTML = 'For ' + who + ', we would send <em>these three.</em>';
    rSub.textContent = 'Chosen from the pieces we engrave most often, not from the whole catalogue. Standard personalization is included on every one.';

    rPicks.innerHTML = '';
    list.forEach(function (x) {
      var p = x.p;
      var a = document.createElement('a');
      a.className = 'pick';
      a.href = p.url;
      a.innerHTML =
        '<div class="pimg">' + (p.img ? '<img src="' + p.img + '" alt="' + p.v + ' ' + p.n + '" loading="lazy">' : '') + '</div>' +
        '<div class="pb"><span class="brand">' + p.v + '</span><h4>' + p.n + '</h4>' +
        '<p class="why">' + p.cut + (budgetNote(p) ? ' <b style="color:var(--golds);font-weight:600">' + budgetNote(p) + '.</b>' : '') + '</p>' +
        '<div class="pp"><span>' + money(p) + '</span><span>Engraving free</span></div></div>';
      if (p.quote) {
        var box = a.querySelector('.pimg');
        box.style.background = '#221c19';
        box.style.padding = '0';
        box.innerHTML = p.img ? '<img src="' + p.img + '" alt="' + p.n + '" style="mix-blend-mode:normal;object-fit:cover;width:100%;height:100%" loading="lazy">' : '';
      }
      rPicks.appendChild(a);
    });

    if (pick.occasion) {
      rTiming.innerHTML = '<b>Timing.</b> ' + LEAD[pick.occasion] +
        ' The 3D photo crystal needs longer than glassware. If your date is tighter than that, email us and we will tell you the truth rather than take the order.';
      rTiming.hidden = false;
    } else { rTiming.hidden = true; }

    rMail.href = 'mailto:' + (rMail.dataset.email || 'hello@crystalhouse.us') + '?subject=' + encodeURIComponent('Wedding gift help') +
      '&body=' + encodeURIComponent('Hi Elias,\n\nFrom the guide on your site, these three came up for me:\n\n' +
        list.map(function (x) { return '- ' + x.p.v + ' ' + x.p.n + ' (' + money(x.p) + ')'; }).join('\n') +
        '\n\nRecipient: ' + (pick.recipient || 'not set') +
        '\nOccasion: ' + (pick.occasion || 'not set') +
        '\nStyle: ' + (pick.style || 'not set') +
        '\nBudget: ' + (pick.budget || 'not set') + '\n\nMy wedding date is ');
    rCta.hidden = false;
  }

  [].forEach.call(document.querySelectorAll('.tile[data-recipient]'), function (t) {
    t.addEventListener('click', function () {
      pick.recipient = t.dataset.recipient;
      [].forEach.call(els.recipient.children, function (c) {
        c.setAttribute('aria-pressed', c.dataset.v === pick.recipient ? 'true' : 'false');
      });
      render();
      document.getElementById('curate').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  render();
})();